import PropTypes from "prop-types";
import React, { Component } from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { userIsAuthenticated, userIsNotAuthenticated } from "./auth";
import NotFoundPage from "components/NotFoundPage";
import ErrorBoundary from "./ErrorBoundary";
import LayoutContainer from "containers/LayoutContainer";
import CoreLayout from "containers/CoreLayout";
import {
  Login,
  LoginSso,
  ChangePassword,
  ForgotPassword,
  ResetPassword,
  TimeLogs,
  Register,
  InternetUserList,
  InternetUser,
  CreateUser,
  Logout,
  AppraiserInterview,
} from "containers/User";
import {
  TwoFactorAuthSetup,
  TwoFactorAuthLogin,
  Profile,
  WindowRedirect,
} from "components/User";
import Home from "containers/Home";
import Refresh from "containers/Refresh";
import CaseProfile from "containers/Homeowner/CaseProfile/CaseProfile";
import BrokerCase from "containers/Broker/BrokerCase";
import Waiver from "containers/Broker/Waiver";
import AppraiserList from "containers/Appraiser";
import ChangeStatus from "containers/Appraiser/ChangeStatus";
import Comparable from "containers/Appraiser/Comparable";
import AppraiserProfile from "containers/Appraiser/Profile";
import AppraiserCreate from "containers/Appraiser/Create";
import {
  AssignmentInsurance,
  AssignmentAppraisal
} from "containers/Assignment";
import SearchResult from "containers/Search/SearchResult";
import { OrderConfirmation, CheckoutPage } from "containers/WebOrder";
import Maintenance from "containers/Maintenance";
import { FieldManagerTerritoryAssignment, LLMTerritoryAssignment, AppraiserSupportTerritoryAssignment} from "containers/Region";
import BrokerMaintenance from "containers/Broker/BrokerMaintenance";
import { CaseView, AgentProfile, QATimeLogs, QAMac } from "containers/QualityAssurance";
import SATimeLogs from "components/CallCenter/SchedulingAssistant/SchedulingAssistantTimelogs.tsx";
import Mac from "containers/Mac";
import FieldRepList from "containers/Homeowner/Insurance/FieldRepList";
import FieldRepProfile from "containers/Homeowner/Insurance/FieldRepProfile";
import RoleRights from "containers/User/RoleRights";
import QuickLists from "containers/QuickLists";
import KeepSharedList from "components/QuickLists/KeepSharedList";
import webConfig from "middlewares/WebConfig";
import JordanTestPage from "components/Assignment/JordanTestPage.tsx";
import LukeTestPage from "components/Assignment/LukeTestPage";
import DonTestPage from "components/Assignment/DonTestPage";
import AnandTestPage from "../../../tests/components/AnandTestPage";
import ESmallTestPage from "../../../tests/components/ESmallTestPage.tsx";
import KHoranTestPage from "../../../tests/components/KHoranTestPage";
import { ASSIGNMENT_APPRAISAL_TITLE, ASSIGNMENT_INSURANCE_TITLE } from "components/Assignment";
import MCaseView from "../Homeowner/MCaseView";
import { CustomerScorecard } from "containers/Homeowner/Customer";
import NewCompGridDemo from "../../components/Homeowner/CaseForms/ComparableGrid/NewCompGridDemo";
import Order from "containers/Homeowner/Customer/Order";
import * as rights from "typeConstants/rights";
import {
  CustomerAgentList,
  CustomerAgentProfile,
  CustomerAgentCreate,
} from "../../containers/Customer/Agent";
import { ExpiredPasswordModal } from "components/Shared";
import CustomerFeedback from "components/Customer/Feedback";
import { PhoenixAtHome } from "components/PhoenixIntegration";
import HiringNeed from "components/HiringNeed";
import ExclusionSearch from "components/Appraiser/ExclusionSearch";
import RequestExtension from "components/Homeowner/FieldReps/RequestExtension";
import EmployeeTimeLogs from "components/EmployeeTimeLogs";
import * as employeeRoles from "typeConstants/employeeRoles";
import AppraiserCoverage from "components/Coverage/AppraiserCoverage";
import CustomerList from "components/Customer/List/CustomerList.tsx";
import { APPRAISER_CUSTOMER_EXCLUSIONS, FIELD_REP_CUSTOMER_EXCLUSIONS } from "typeConstants/paths";
import Payroll from "components/EmployeeTimeLogs/Payroll.tsx";
import ManageCourses from "components/Courses";
import ManageCourseGroups from "components/Courses/ManageCourseGroups";
import EmployeeList from "components/Employee/EmployeeList";
import FieldRepOrderQueue from "components/Homeowner/FieldReps/FieldRepOrderQueue";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";
import WebOrderV2 from "components/WebOrderV2/index.tsx";
import { SchedulingAssistantView } from "components/CallCenter";
import BulkAutoQA from "components/QualityAssurance/Other/BulkAutoQA";
import FieldRepTimeCardPage from "components/Shared/TimeLogs/FieldRepTimeCardPage.tsx";
import TrainingResources from "components/TrainingResources";
import ServiceRegionList from "components/ServiceRegions";
import WatchGroupDelete from "components/Watches/WatchGroupDelete";
import AppraiserQueueRoute from "components/Appraiser/AppraiserQueueRoute.tsx";
import SchedulingUserList from "components/CallCenter/SchedulingAssistant/SchedulingAssistantList.tsx";
import EmployeeCalendarRoute from "components/Employee/EmployeeCalendarRoute.tsx";
import CaseConfigurations from "components/Customer/CaseConfigurations/index.tsx";
import CustomerProfile from "components/Customer/Profile/index.tsx";
import PhoneSupportForm from "components/CallCenter/PhoneSupportForm/PhoneSupportForm.tsx";
import CoachingPhoneSupportForm from "components/CallCenter/PhoneSupportForm/CoachingPhoneSupportForm.tsx";
import CustomerSurveyTypes from "components/Customer/SurveyTypes/CustomerSurveyTypes.tsx";
import CustomerSurveyTypeDetails from "components/Customer/SurveyTypes/CustomerSurveyTypeDetails.tsx";
import UWPermissionToCloseResponse from "components/Homeowner/CaseActions/UWPermissionToCloseResponse.tsx";
import UWPermissionToExtendResponse from "components/Homeowner/CaseActions/UWPermissionToExtendResponse.tsx";
import CaseDuplicateFromRoute from "components/Homeowner/CaseForms/Actions/CaseDuplicateFromRoute.tsx";
import CustomerInvoicing from "components/Customer/CustomerInvoicing.tsx";
import CustomerSatisfactionSurvey from "components/SatisfactionSurvey/CustomerSatisfactionSurvey.tsx";
import ContentManagementList from "components/CMS/ContentManagementList.tsx";
import QADepartmentList from "containers/QualityAssurance/QADepartmentList.tsx";
import SupportLineSatisfactionSurvey from "components/SatisfactionSurvey/SupportLineSatisfactionSurvey.tsx";
import QADashboard from "components/QualityAssurance/Views/QADashboard.tsx";
import PhoenixFormsList from "components/PhoenixFormsV4/PhoenixFormsDesigner/PhoenixFormsList.tsx";
import OnboardingSatisfactionSurvey from "components/SatisfactionSurvey/OnboardingSatisfactionSurvey.tsx";
import QueueMappings from "components/EmployeeCustomerSurveyTypes/QueueMappings.tsx";
import PublicFormPreview from "components/PhoenixFormsV4/PhoenixFormsDesigner/PublicFormPreview.tsx";
import PhoenixFormDesigner from "components/PhoenixFormsV4/PhoenixFormsDesigner/Designer/index.tsx";
import PhoenixPdfDesigner from "components/PhoenixFormsV4/PhoenixFormsDesigner/PDFDesigner/PhoenixPdfDesignerContext.tsx";
import OperationsManagementList from "components/Employee/OperationsEmployees/OperationsManagementList.tsx";
import PhotoPopOutContainer from "containers/Photos/PhotoPopOutContainer.tsx";
import CustomerInsightsSurvey from "components/SatisfactionSurvey/CustomerInsightsSurvey.tsx";
import EmployeeCalendarList from "components/Employee/EmployeeCalendarList.tsx";

// Determine what authenticated routes are allowed based on the supplied roles and rights
const AuthorizedRoutes = (userRoles, userRights, appraiserTitle, multiFactorRequired, multiFactorSetupRequired, maintenanceSections) => {
  let routePaths = [];
  let routes = [];

  let addRoute = route => {
    // Make sure route path is only added once
    if (routePaths.indexOf(route.props.path) >= 0) return;
    routePaths.push(route.props.path);
    routes.push(route);
  };

  if (multiFactorRequired) {
    addRoute(
      <Route
        key="two-factor-auth"
        path="/two-factor-auth"
        component={TwoFactorAuthLogin}
      />
    );
    return (
      <Switch>{routes}</Switch>
    );
  }

  let homeRoute = Home;
  if (userRights.includes(rights.QUICKLIST_VIEW)) {
    homeRoute = QuickLists;
  } 
  else if (userRights.includes(rights.CALENDAR_HOME_SCREEN)) {
    homeRoute = EmployeeCalendar;
  } 

  // Everyone can go to these routes
  addRoute(
    <Route
      key="slash"
      exact path="/"
      component={homeRoute}
      topMenuTitle="Home"
    />
  );
  addRoute(
    <Route
      key="logout"
      exact path="/logout"
      component={Logout}
      topMenuTitle="Logout"
    />
  );
  addRoute(
    <Route
      key="redirect"
      exact path="/redirect"
      component={WindowRedirect}
      topMenuTitle="Connecting"
    />
  );
  addRoute(
    <Route
      key="refesh"
      exact
      path="/refresh"
      component={userRights.includes(rights.QUICKLIST_VIEW) ? QuickLists : Refresh}
      topMenuTitle="Home"
    />
  );
  addRoute(
    <Route
      key="customer-order"
      path="/batch-order"
      component={(userRights.includes(rights.ORDER) || userRights.includes(rights.PLACE_ORDER_VIEW)) ? Order : Refresh}
      topMenuTitle="Order"
    />
  );
  addRoute(
    <Route
      key="profile"
      path="/profile"
      component={Profile}
      topMenuTitle="My profile"
    />
  );
  addRoute(
    <Route
      key="change-password"
      path="/change-password"
      component={ChangePassword}
      topMenuTitle="Change Password"
    />
  );
  addRoute(
    <Route
      key="change-password-required"
      path="/change-password-required"
      component={ExpiredPasswordModal}
      topMenuTitle="Password Change Required"
    />
  );
  addRoute(
    <Route
      key="search-results"
      path="/search-results"
      component={SearchResult}
      topMenuTitle="Search Results"
    />
  );
  addRoute(
    <Route
      key="dashboard"
      path="/dashboard"
      component={Home} //{Dashboard}
      topMenuTitle="Dashboard"
    />
  );
  // everybody can view case profile if the search result brings the case
  // we can have a right instead and assign it to roles which can actually view cases...
  addRoute(
    <Route key="case-profile" path="/case-profile"
      component={CaseProfile}
      topMenuTitle="Case Profile"
    />
  );
  addRoute(
    <Route
      key="new-case-view"
      path="/case"
      component={MCaseView}
      topMenuTitle="Case Details"
    />
  );
  // Add on allowed paths for each role the user has
  if (userRoles) {
    userRoles.forEach(userRole => {
      switch (userRole) {
        case "MortgageBroker":
          addRoute(
            <Route
              key="Broker-Maintenance"
              path="/Broker-Maintenance"
              component={BrokerMaintenance}
              topMenuTitle="Broker Settings"
            />
          );
          addRoute(
            <Route
              key="order-confirmation"
              path="/order-confirmation"
              component={OrderConfirmation}
              topMenuTitle="Order Confirmation"
            />
          );
          addRoute(
            <Route
              key="broker-case"
              path="/broker-case"
              component={BrokerCase}
              topMenuTitle="Mortgage Broker Case Details"
            />
          );
          addRoute(
            <Route
              key="maintenance"
              path="/maintenance"
              component={Maintenance}
              topMenuTitle="Maintenance"
            />
          );
          break;
        case "MuellerAppraiser":
          addRoute(
            <Route
              key="timelog"
              path="/timelog"
              component={TimeLogs}
              topMenuTitle="My Time Logs"
            />
          );
          break;
        case "MuellerAppraiserManager":
        case "MuellerAppraiserSupport":
        case "IT":
          addRoute(
            <Route
              key="timelog"
              path="/timelog"
              component={TimeLogs}
              topMenuTitle="My Time Logs"
            />
          );
          addRoute(
            <Route
              key="appraiser"
              path="/appraiser"
              exact
              component={AppraiserList}
              topMenuTitle="Appraisers"
            />
          );
          addRoute(
            <Route
              key="appraiser-profile"
              path="/appraiser/profile"
              component={AppraiserProfile}
              topMenuTitle={`Appraiser Profile${appraiserTitle}`}
            />
          );
          addRoute(
            <Route
              key="appraiser-create"
              path="/appraiser/create"
              component={AppraiserCreate}
              topMenuTitle="Add New Appraiser"
            />
          );
          addRoute(
            <Route
              key="change-status"
              path="/change-status"
              component={ChangeStatus}
              topMenuTitle="Change Case Status"
            />
          );
          addRoute(
            <Route
              key="scheduling-assistant-case-view"
              path="/scheduling-assistant/case-view"
              component={SchedulingAssistantView}
              topMenuTitle="Field Services Scheduling"
              rootCssClass="flex"
            />);
          break;
        case "CustomerServiceEmployee":
          addRoute(
            <Route
              key="timelog"
              path="/timelog"
              component={TimeLogs}
              topMenuTitle="My Time Logs"
            />
          );
          break;
        case "QualityAssuranceDirector":
        case "QualityAssuranceEmployee":
        case "QualityAssuranceManager":
          addRoute(
            <Route
              key="bizops-case-view"
              path="/bizops/case-view"
              component={CaseView}
              topMenuTitle=""
              rootCssClass="flex"
            />);
          break;
        case "Field Scheduling Team Leader":
        case "Customer Experience Rep":
        case "Customer Experience Manager":
        case "Customer Experience Director":
          addRoute(
            <Route
              key="scheduling-assistant-case-view"
              path="/scheduling-assistant/case-view"
              component={SchedulingAssistantView}
              topMenuTitle="Field Services Scheduling"
              rootCssClass="flex"
            />);
          break;
      }
    });
  }

  // Add on allowed paths for each right the user has
  if (userRights) {
    userRights.forEach(userRight => {
      switch (userRight) {
        case rights.ADD_NEW_APPRAISER:
          addRoute(
            <Route
              key="appraiser-create"
              path="/appraiser/create"
              component={AppraiserCreate}
              topMenuTitle="Add New Appraiser"
            />
          );
          break;
        case rights.APPRAISER_EDIT:
          addRoute(
            <Route
              key="appraiser-profile"
              path="/appraiser/profile"
              component={AppraiserProfile}
              topMenuTitle="Appraiser Profile"
            />
          );
          break;
        case rights.APPRAISER_SUPPORT_REGION_MAINTENANCE:
          addRoute(
            <Route
              key="appraiser-support"
              path="/appraiser-support"
              component={AppraiserSupportTerritoryAssignment}
              topMenuTitle="Appraiser Manager Territory Assignment"
            />
          );
          break;
        case rights.FLC_REGION_MAINTENANCE:
          addRoute(
            <Route
              key="appraiser-support"
              path="/flc-support"
              component={FieldManagerTerritoryAssignment}
              topMenuTitle="Field Manager Territory Assignment"
            />
          );
          addRoute(
            <Route
              key="llm-regions"
              path="/llm-regions"
              component={LLMTerritoryAssignment}
              topMenuTitle="Lender Logistics Manager Territory Assignment"
            />
          );
          break;
        case rights.APPRAISER_VIEW:
          addRoute(
            <Route
              key="appraiser"
              path="/appraiser"
              exact
              component={AppraiserList}
              topMenuTitle="Appraisers"
            />
          );
          addRoute(
            <Route
              key="change-status"
              path="/change-status"
              component={ChangeStatus}
              topMenuTitle="Change Case Status"
            />
          );
          addRoute(
            <Route
              key="appraiser-cases"
              path="/appraiser-cases/:appraiserId"
              component={AppraiserQueueRoute}
              topMenuTitle="Appraiser Order Queue"
            />
          );
          break;
        case rights.ASSIGN:
        case rights.ASSIGNMENTTOOLINSURANCE:
          addRoute(
            <Route
              key="assignment-tool-insurance"
              path="/assignment-tool-insurance"
              component={AssignmentInsurance}
              topMenuTitle={ASSIGNMENT_INSURANCE_TITLE}
            />
          );
          break;
        case rights.FIELDREPLIST_VIEW:
          addRoute(
            <Route
              key="field-rep-list"
              path="/field-rep-list"
              component={FieldRepList}
              topMenuTitle="Field Reps"
            />
          );
          break;
        case rights.FIELDREPPROFILE_VIEW:
          addRoute(
            <Route
              key="field-rep-profile"
              path="/field-rep-profile"
              component={FieldRepProfile}
              topMenuTitle="Field Rep Profile"
            />
          );
          addRoute(
            <Route
              key="inspector-cases"
              path="/inspector-cases"
              component={FieldRepOrderQueue}
              topMenuTitle="Field Rep Order Queue"
            />
          );
          break;
        case rights.ASSIGNMENTTOOLAPPRAISAL:
          addRoute(
            <Route
              key="assignment-tool-appraisal"
              path="/assignment-tool-appraisal"
              component={AssignmentAppraisal}
              topMenuTitle={ASSIGNMENT_APPRAISAL_TITLE}
            />
          );
          break;
        case rights.CUSTOMER_SCORECARD_VIEW:
          addRoute(
            <Route
              key="customer/scorecard"
              path="/customer/scorecard"
              component={CustomerScorecard}
              topMenuTitle="Scorecard"
            />
          );
          break;
        case rights.QA:
          addRoute(
            <Route
              key="bizops-case-view"
              path="/bizops/case-view"
              component={CaseView}
              topMenuTitle="QA Case"
              rootCssClass="flex"
            />
          );
          break;
        case rights.TEAMLEADER:
          addRoute(
            <Route
              key="bizops-case-view"
              path="/bizops/case-view"
              component={CaseView}
              topMenuTitle="QA Case"
              rootCssClass="flex"
            />);
          break;
        case rights.AUTHENTICATION_VIEW:
          addRoute(
            <Route
              key="maintenance"
              path="/maintenance"
              component={Maintenance}
              topMenuTitle="Maintenance"
            />
          );
          addRoute(
            <Route
              key="internet-user"
              path="/internet-user"
              component={InternetUserList}
              topMenuTitle="Authentication"
            />
          );
          addRoute(
            <Route
              key="user-profile"
              path="/user-profile"
              component={InternetUser}
              topMenuTitle="Authentication Profile"
            />
          );
          break;
        case rights.AUTHENTICATION_EDIT:
          addRoute(
            <Route
              key="maintenance"
              path="/maintenance"
              component={Maintenance}
              topMenuTitle="Maintenance"
            />
          );
          addRoute(
            <Route
              key="internet-user"
              path="/internet-user"
              component={InternetUserList}
              topMenuTitle="Authentication"
            />
          );
          addRoute(
            <Route
              key="user-profile"
              path="/user-profile"
              component={InternetUser}
              topMenuTitle="Authentication Profile"
            />
          );
          addRoute(
            <Route
              key="create-user"
              path="/create-user"
              component={CreateUser}
              topMenuTitle="Create User"
            />
          );
          break;
        case rights.APPRAISER_MAC_BONUS_SHOW:
          addRoute(<Route key="mac" path="/mac" component={Mac} topMenuTitle="MAC" />);
          break;
        case rights.BUSOPS_AGENT_MAC_BONUS_SHOW:
          addRoute(<Route key="mac" path="/mac" component={QAMac} topMenuTitle="MAC" />);
          break;
        case rights.ROLE_RIGHTS_VIEW:
          addRoute(<Route key="role-rights" path="/role-permissions" component={RoleRights} topMenuTitle="Role Permissions" />);
          break;
        case rights.BUSOPS_TIMELOGS_VIEW:
          addRoute(<Route key="busops-timelog" path="/busops-timelog" component={QATimeLogs} topMenuTitle="My Time Logs" />);
          break;
        case rights.QA_DASHBOARD_VIEW:
          addRoute(<Route key="qa-dashboard" path="/qa-dashboard" component={QADashboard} topMenuTitle="QA Dashboard" />);
          break;
        case rights.SCHEDULING_ASSISTANT_VIEW_MY_TIME_LOGS:
          addRoute(<Route key="sa-timelog" path="/sa-timelog" component={SATimeLogs} topMenuTitle="My Time Logs" />);
          break;
        case rights.SCHEDULING_ASSISTANTS_TIMELOGS_VIEW:
          addRoute(
            <Route
              key="scheduling-ass-employee-timelogs"
              path="/sa/timelogs/approve"
              render={(props) => <EmployeeTimeLogs employeeRole={employeeRoles.CUSTOMER_EXPERIENCE_REP} {...props} />}
              topMenuTitle="Employee Time Logs"
            />
          );
          break;
        case rights.QA_LIST_VIEW:
        case rights.QAM_LIST_VIEW:
          addRoute(<Route key="qa-department" path="/qa-department" component={QADepartmentList} topMenuTitle="QA Department" />);
          addRoute(<Route key="qa-agent-profile" path="/qa-agent-profile" component={AgentProfile} topMenuTitle="Agent Profile" />);
          break;
        case rights.QUICKLIST_VIEW:
          addRoute(<Route key="static-quick-lists" path="/static-quick-lists" component={QuickLists} topMenuTitle="Quick Lists" />);
          addRoute(<Route key="get-quick-list" path="/get-shared-quick-list" component={KeepSharedList} topMenuTitle="Get Shared Quick List" />);
          break;
        case rights.BUSOPS_TIMELOGS_APPROVE:
          addRoute(<Route key="busops-timelogs-approve" path="/busops/timelogs/approve"
            render={(props) => <EmployeeTimeLogs employeeRole={employeeRoles.BUSOP_AGENT} {...props} />}
            topMenuTitle="Employee Time Logs" />);
          break;
        case rights.CASE_PROFILE_VIEW:
          // this component is also called without the Router.
          addRoute(<Route key="case-profile" path="/case-profile"
            component={CaseProfile}
            topMenuTitle="Case Profile" />);
          break;
        case rights.CUSTOMER_AGENT_VIEW:
          addRoute(<Route key="customer-agents" path="/customer-agents" component={CustomerAgentList} topMenuTitle="Customer Agent List" />);
          addRoute(<Route key="customer-agent-profile" path="/customer-agent/profile" component={CustomerAgentProfile} topMenuTitle="Customer Agent Profile" />);
          break;
        case rights.CUSTOMER_AGENT_CREATE:
          addRoute(<Route key="customer-agent-create" path="/customer-agent/create" component={CustomerAgentCreate} topMenuTitle="Add New Customer Agent" />);
          break;
        case rights.APPRAISER_TIMELOGS_APPROVE_VIEW:
          addRoute(
            <Route
              key="appraiser-employee-timelogs"
              path="/appraiser/timelogs/approve"
              render={(props) => <EmployeeTimeLogs employeeRole={employeeRoles.VALUATION_APPRAISER} {...props} />}
              topMenuTitle="Employee Time Logs"
            />
          );
          break;
        case rights.QUICKLIST_INSPECTOR_HIRING_FORECAST_TEMPLATE_VIEW:
          addRoute(
            <Route
              key="hiring-need"
              path="/hiring-need"
              component={HiringNeed}
              topMenuTitle="Hiring Needs Details"
            />
          );
          break;
        case rights.APPRAISAL_COVERAGE_MAP:
          addRoute(
            <Route
              key="appraisal-coverage-map"
              path="/appraiser-coverage"
              component={AppraiserCoverage}
              rootCssClass="appraiser-coverage-height"
            />
          );
          break;
        case rights.CUSTOMER_LIST_VIEW:
          addRoute(
            <Route
              key="customer-list"
              path="/customer/search"
              topMenuTitle="Customers"
              render={(props) =>
                <CustomerList
                splitComponent={<CustomerProfile verticalDisplay />}
                splitComponentTitle="Account Profile"
                {...props}
              />}
            />
          );
          break;
        case rights.PAYROLL_VIEW:
          addRoute(
            <Route
              key="payroll"
              path="/payroll"
              topMenuTitle="Run Payroll"
              component={Payroll}
            />
          );
          break;
        case rights.COURSE_VIEW:
          addRoute(
            <Route
              key="manage-courses"
              path="/manage-courses"
              topMenuTitle="Courses"
              component={ManageCourses}
            />
          );
          addRoute(
            <Route
              key="manage-course-groups"
              path="/manage-course-groups"
              topMenuTitle="Manage Course Categories"
              component={ManageCourseGroups}
            />
          );
          break;
        case rights.EMPLOYEE_CONTACT_VIEW:
          addRoute(
            <Route
              key="employee-list"
              path="/manage-employees"
              topMenuTitle="Employees"
              component={EmployeeList}
            />
          );
          break;
        case rights.EMPLOYEE_CALENDAR_EDIT:
          addRoute(
            <Route
              key="employee-calendar"
              path="/employee/calendar"
              component={EmployeeCalendar}
              topMenuTitle="My Calendar"
            />
          );
          break;
        case rights.ORDER:
        case rights.PLACE_ORDER_VIEW:
          addRoute(
            <Route
              key="order"
              path="/order"
              component={WebOrderV2}
              topMenuTitle="Order"
            />
          );
          addRoute(
            <Route
              key="re-order"
              path="/re-order/:controlNumber"
              component={CaseDuplicateFromRoute}
              topMenuTitle="Re-Order"
            />
          );
          break;
        case rights.SERVICE_REGION_VIEW:
          addRoute(
            <Route
              key="service-regions"
              path="/service-regions"
              component={ServiceRegionList}
              topMenuTitle="MSA Maintenance"
            />
          );
          break;
        case rights.FIELD_SCHEDULING_MANAGE:
          addRoute(
            <Route
              key="scheduling-assistants"
              path="/scheduling-assistants"
              topMenuTitle="Field Scheduling Assistants"
              component={SchedulingUserList}
            />
          );
          break;
        case rights.CASE_CONFIGURATIONS_EDIT:
          addRoute(
            <Route
              key="case-configurations"
              path="/case-configurations"
              topMenuTitle="Case Configurations"
              render={(props) =>
                <CustomerList
                splitComponent={<CaseConfigurations />}
                splitComponentTitle="Case Configurations"
                {...props}
              />}
              />
          );
          break;
        case rights.PHONE_SUPPORT_CALL_VIEW:
          addRoute(
            <Route
              key="phone-support-call-view"
              path="/support-calls"
              topMenuTitle="Phone Support Form"
              component={PhoneSupportForm}
            />
          );
          break;
        case rights.QA_PHONE_SUPPORT_COACHING_CALL:
          addRoute(
            <Route
              key="phone-support-call-view"
              path="/coaching-calls"
              topMenuTitle="Coaching Phone Support Form"
              component={CoachingPhoneSupportForm}
            />
          );
          break;
        case rights.CUSTOMER_SURVEY_TYPE_VIEW:
          addRoute(
            <Route
              key="Customer Survey Types"
              path="/customer/survey-types"
              topMenuTitle="Customer Survey Types"
              render={(props) =>
                <CustomerSurveyTypes
                  splitComponent={<CustomerSurveyTypeDetails verticalDisplay />}
                  splitComponentTitle="Survey Type Details"
                  {...props}
                />}
            />
          );
          addRoute(
            <Route
              key="Customer Survey Type"
              path="/customer/survey-type"
              topMenuTitle="Customer Survey Type"
              render={(props) =>
                <CustomerSurveyTypeDetails verticalDisplay={false} {...props} />}
            />
          );
          break;
        case rights.CUSTOMER_INVOICING_MAINTENANCE:
          addRoute(
            <Route
              key="Customer Invoicing"
              path="/customer/invoicing"
              topMenuTitle="Customer Invoicing"
              component={CustomerInvoicing}
            />
          );
          break;
        case rights.CONTENT_LIBRARY_VIEW:
        case rights.CONTENT_LIBRARY_EDIT:
          addRoute(
            <Route
              key="cms-list"
              path="/content-management/list"
              component={ContentManagementList}
              topMenuTitle="Content Management"
            />
          );
          break;
        case rights.FORM_MAINTENANCE_VIEW:
          addRoute(
            <Route
              key="form-maintenance-list"
              path="/phoenixforms-designer/forms-list"
              component={PhoenixFormsList}
              topMenuTitle="Forms List"
            />
          );
          break;
        case rights.FORM_DESIGN_EDIT:
          addRoute(
            <Route
              key="phoenix-form-designer"
              path="/phoenixforms-designer/:phoenixFormId"
              component={PhoenixFormDesigner}
            />
          );
          addRoute(
            <Route
              key="phoenix-pdf-designer"
              path="/phoenix-pdf-designer/:phoenixPdfId"
              component={PhoenixPdfDesigner}
            />
          );
          break;
        case rights.HOMEOWNERS_QA_QUEUE_MAPPING_VIEW:
        case rights.AUDIT_QA_QUEUE_MAPPING_VIEW:
        case rights.PREFERRED_APPOINTMENT_QUEUE_MAPPING_VIEW:
        case rights.FIELD_APPOINTMENT_QUEUE_MAPPING_VIEW:
          addRoute(
            <Route 
              key="customer-employee-mapping"
              path="/customer/employee-mapping"
              component={QueueMappings}
              topMenuTitle="Queue Mappings"
            />
          );
          break;
        case rights.OPERATIONS_MANAGER_PROFILE_VIEW:
        case rights.OPERATIONS_MANAGER_PROFILE_EDIT:
        case rights.OPERATIONS_DIRECTOR_PROFILE_VIEW:
        case rights.OPERATIONS_DIRECTOR_PROFILE_EDIT:
          addRoute(
            <Route
              key="operations-management-profiles"
              path="/operations-management-profiles"
              component={OperationsManagementList}
              topMenuTitle="Operations Management"
            />
          );
          break;
        case rights.PHOTO_WRITE_UNRESTRICTED:
          addRoute(
            <Route
              key="pop-out-photo-tool"
              path="/photo/pop-out"
              component={PhotoPopOutContainer}
            />
          );
          break;
      }
    });
  }

  // Add training resources if the user has more than 1 training right
  let trainingRights = [
    rights.FIELD_TRAINING_VIEW,
    rights.QA_CASES_VIEW,
    rights.APPRAISAL_TRAINING_VIEW
  ];
  let totalTrainingRights = userRights.filter(r => trainingRights.includes(r)).length;
  if (totalTrainingRights > 1)
  {
    addRoute(
      <Route
        key="training"
        path="/training/resources"
        component={TrainingResources}
        topMenuTitle="Training Resources"
      />
    );
  }

  // Add maintenance route if user has access to maintenance side bar (same check as in Mueller\Projects\WebApi\Services\Implementations\UserMenuBuilder.cs)
  let maintenanceRights = [
    rights.APPRAISER_SUPPORT_REGION_MAINTENANCE,
    rights.APPRAISER_VIEW,
    rights.AUTHENTICATION_LIST,
    rights.FIELDREPLIST_VIEW,
    rights.BUSOPS_TIMELOGS_APPROVE,
    rights.PLACE_ORDER_VIEW,
    rights.SERVICE_REGION_VIEW,
    rights.FLC_REGION_MAINTENANCE,
    rights.FIELD_REP_TIMELOGS_APPROVE_VIEW,
    rights.CASE_STATUS_CHANGE,
    rights.APPRAISER_TIMELOGS_APPROVE,
    rights.ROLE_RIGHTS_VIEW,
    rights.QA_LIST_VIEW,
    rights.CUSTOMER_LIST_VIEW,
    rights.CUSTOMER_AGENT_VIEW,
    rights.CUSTOMER_APPRAISER_EXCLUSION_MAINTENANCE,
    rights.CUSTOMER_INSPECTOR_EXCLUSION_MAINTENANCE,
    rights.FIELD_SERVICE_AUTO_QA_BATCH_ADD,
    rights.FIELD_SCHEDULING_MANAGE,
    rights.MANAGEMENT_CALENDAR_VIEW,
  ];

  if (userRights.filter(r => maintenanceRights.includes(r)).length > 0) {
    addRoute(
      <Route
        key="maintenance"
        path="/maintenance"
        component={Maintenance}
        topMenuTitle="Maintenance"
      />
    );
  }

  // Add on allowed routes based on maintenanceCards
  if (maintenanceSections?.length) {
    maintenanceSections.forEach(s =>
      s.maintenanceCards.forEach(maintCard => {
        switch (maintCard.path) {
          case "/busops/timelogs/approve":
            addRoute(<Route key="busops-timelogs-approve" path="/busops/timelogs/approve"
              render={(props) => <EmployeeTimeLogs employeeRole={employeeRoles.BUSOP_AGENT} {...props} />}
              topMenuTitle="Employee Time Logs" />);
            break;
          case "/field-rep-list":
            addRoute(
              <Route
                key="field-rep-list"
                path="/field-rep-list"
                component={FieldRepList}
                topMenuTitle="Field Reps"
              />
            );
            break;
          case "/flc-support":
            addRoute(
              <Route
                key="appraiser-support"
                path="/flc-support"
                component={FieldManagerTerritoryAssignment}
                topMenuTitle="Field Manager Territory Assignment"
              />
            );
            break;
          case "/appraiser":
            addRoute(
              <Route
                key="appraiser"
                path="/appraiser"
                exact
                component={AppraiserList}
                topMenuTitle="Appraisers"
              />
            );
            break;
          case "/appraiser-support":
            addRoute(
              <Route
                key="appraiser-support"
                path="/appraiser-support"
                component={AppraiserSupportTerritoryAssignment}
                topMenuTitle="Appraiser Manager Territory Assignment"
              />
            );
            break;
          case "/appraiser/timelogs/approve":
            addRoute(<Route
              key="appraiser-employee-timelogs"
              path="/appraiser/timelogs/approve"
              render={(props) => <EmployeeTimeLogs employeeRole={employeeRoles.VALUATION_APPRAISER} {...props} />}
              topMenuTitle="Employee Time Logs"
            />);
            break;
          case "/change-status":
            addRoute(
              <Route
                key="change-status"
                path="/change-status"
                component={ChangeStatus}
                topMenuTitle="Change Case Status"
              />
            );
            break;
          case "/internet-user":
            addRoute(
              <Route
                key="internet-user"
                path="/internet-user"
                component={InternetUserList}
                topMenuTitle="Authentication"
              />
            );
            break;
          case "/role-permissions":
            addRoute(
              <Route key="role-rights"
                path="/role-permissions"
                component={RoleRights}
                topMenuTitle="Role Permissions"
              />);
            break;
          case "/field-rep/timelogs/approve":
            addRoute(<Route
              key="field-rep-employee-timelogs"
              path="/field-rep/timelogs/approve"
              component={FieldRepTimeCardPage}
              topMenuTitle="Employee Time Logs"
            />);
            break;
          case `/${APPRAISER_CUSTOMER_EXCLUSIONS}`:
            addRoute(<Route
              key={APPRAISER_CUSTOMER_EXCLUSIONS}
              path={`/${APPRAISER_CUSTOMER_EXCLUSIONS}`}
              component={ExclusionSearch}
              topMenuTitle="Appraiser Customer Exclusion Search"
            />);
            break;
          case "/customer/search":
            addRoute(
              <Route
                key="customer-list"
                path="/customer/search"
                topMenuTitle="Customers"
                render={(props) =>
                  <CustomerList
                  splitComponent={<CustomerProfile verticalDisplay />}
                  splitComponentTitle="Account Profile"
                  {...props}
                />}
              />
            );
            break;
          case `/${FIELD_REP_CUSTOMER_EXCLUSIONS}`:
            addRoute(<Route
              key={FIELD_REP_CUSTOMER_EXCLUSIONS}
              path={`/${FIELD_REP_CUSTOMER_EXCLUSIONS}`}
              component={ExclusionSearch}
              topMenuTitle="Field Rep Customer Exclusion Search"
            />);
            break;
          case "/bulk-auto-qa":
            addRoute(<Route
              key="bulk-auto-qa"
              path="/bulk-auto-qa"
              component={BulkAutoQA}
              topMenuTitle="Bulk Auto-QA"
            />);
            break;
          case "/service-regions":
            addRoute(
              <Route
                key="service-regions"
                path="/service-regions"
                component={ServiceRegionList}
                topMenuTitle="MSA Maintenance"
              />
            );
            break;
          case "/scheduling-assistants":
            addRoute(
              <Route
                key="scheduling-assistants"
                path="/scheduling-assistants"
                topMenuTitle="Field Scheduling Assistants"
                component={SchedulingUserList}
              />
            );
            break;
          case "/customer/survey-types":
            addRoute(
              <Route
                key="Customer Survey Types"
                path="/customer/survey-types"
                topMenuTitle="Customer Survey Types"
                render={(props) =>
                  <CustomerSurveyTypes
                    splitComponent={<CustomerSurveyTypeDetails verticalDisplay />}
                    splitComponentTitle="Survey Type Details"
                    {...props}
                  />}
              />
            );
            addRoute(
              <Route
                key="Customer Survey Type"
                path="/customer/survey-type"
                topMenuTitle="Customer Survey Type"
                render={(props) =>
                  <CustomerSurveyTypeDetails verticalDisplay={false} {...props} />}
              />
            );
            break;
          case "/employee-list/calendar/qa":
          case "/employee-list/calendar/customer-experience":
            addRoute(
              <Route
                key="Employee Calendars"
                path="/employee-list/calendar/:calType"
                topMenuTitle="Employee Calendars"
                component={EmployeeCalendarList}
              />
            );
            break;
        }
      })
    );
  }

  if (webConfig.environment === "testing" || webConfig.environment === "development") {
    addRoute(<Route key="jordan" path="/jordan" component={JordanTestPage} topMenuTitle="Jordan Test Page" />);
    addRoute(<Route key="luke" path="/luke" component={LukeTestPage} topMenuTitle="Luke Test Page" />);
    addRoute(<Route key="new-comp-grid-demo" path="/NewCompGridDemo" component={NewCompGridDemo} topMenuTitle="New Comp Grid Demo" />);
    addRoute(<Route key="don" path="/don" component={DonTestPage} topMenuTitle="Don Test Page" />);
    addRoute(<Route key="balthrop" path="/balthrop" component={JordanTestPage} topMenuTitle="Balthrop Test Page" />);
    addRoute(<Route key="anand" path="/anand" component={AnandTestPage} topMenuTitle="Anand Test Page" />);
    addRoute(<Route key="esmall" path="/esmall" component={ESmallTestPage} topMenuTitle="Eric Test Page" />);
    addRoute(<Route key="khoran" path="/khoran" component={KHoranTestPage} topMenuTitle="Kevin Test Page" />);
    addRoute(<Route key="error" path="/error" render={() => <ErrorBoundary children={null} force={true} />} topMenuTitle="Error Test Page" />);
  }

  if (multiFactorSetupRequired) {
    addRoute(
      <Route
        key="two-factor-setup"
        path="/two-factor-setup"
        component={TwoFactorAuthSetup}
        topMenuTitle="Two Factor Authentication Setup"
      />);
  }

  return (
    <CoreLayout>
      <Switch>
        {routes}
      </Switch>
    </CoreLayout>
  );
};

class AuthenticatedRoutes extends Component {
  constructor(props, context) {
    super(props, context);
    this.formatAppraiserTitle = this.formatAppraiserTitle.bind(this);
  }

  formatAppraiserTitle(appraiserProfile) {
    if (appraiserProfile) {
      let fullName = appraiserProfile.fullName;
      let appraiserNumber = appraiserProfile.appraiserNumber;
      if (fullName && appraiserNumber) {
        return ` - Editing ${appraiserNumber} - ${fullName}`;
      }
      return "";
    }
    return "";
  }

  render() {
    return AuthorizedRoutes(
      this.props.userRoles,
      this.props.userRights,
      this.formatAppraiserTitle(this.props.appraiserProfile),
      this.props.multiFactorRequired,
      this.props.multiFactorSetupRequired,
      this.props.maintenanceSections,
    );
  }
}

AuthenticatedRoutes.defaultProps = {
  userRoles: [],
  userRights: [],
  appraiserProfile: [],
  multiFactorRequired: false,
  multiFactorSetupRequired: false,
  maintenanceSections: [],
};
AuthenticatedRoutes.propTypes = {
  userRoles: PropTypes.array,
  userRights: PropTypes.array,
  appraiserProfile: PropTypes.object,
  multiFactorRequired: PropTypes.bool,
  multiFactorSetupRequired: PropTypes.bool,
  maintenanceSections: PropTypes.array,
};
// Connect AuthenticatedRoutes to the Redux store
const authenticatedRoutes_mapStateToProps = state => {
  return {
    userRoles: state.user.profile.roles,
    userRights: state.user.profile.rights,
    appraiserProfile: state.appraiser.appraiserProfile,
    multiFactorRequired: state.user.profile.loginResult
      ? state.user.profile.loginResult.multiFactorRequired
      : false,
    multiFactorSetupRequired: state.user.profile.multiFactorSetupRequired,
    maintenanceSections: state.user.maintenanceSections
  };
};
const AuthenticatedRoutesRedux = connect(authenticatedRoutes_mapStateToProps)(
  AuthenticatedRoutes
);

const AuthRoutes = userIsAuthenticated(AuthenticatedRoutesRedux);

function Routes(props) {
  return (
    <ErrorBoundary>
      <LayoutContainer>
        <Switch>
        <Route
            key="checkout"
            path="/checkout-:token"
            component={CheckoutPage}
          />
          <Route
            key="comparable"
            path="/comparable-:token"
            component={Comparable}
          />
          <Route key="waiver" path="/waiver-:token" component={Waiver} />
          <Route key="sso" path="/sso-:SSO" component={LoginSso} />
          <Route
            key="login"
            path="/login"
            component={userIsNotAuthenticated(Login)}
          />
          <Route
            key="reset-password"
            path="/reset-password"
            component={userIsNotAuthenticated(ResetPassword)}
          />
          <Route
            key="forgot-password"
            path="/forgot-password"
            component={userIsNotAuthenticated(ForgotPassword)}
          />
          <Route
            key="register-broker"
            path="/register-broker"
            component={userIsNotAuthenticated(Register)}
          />
          <Route
            key="Appraisal Interview"
            path="/public/appraisers"
            component={userIsNotAuthenticated(AppraiserInterview)}
          />
          <Route
            key="report-feedback"
            path="/report-feedback/:workitemid"
            component={CustomerFeedback}
          />
          <Route
            key="phoenix-at-home"
            path="/phoenixintegration/phoenix-at-home/:fileid"
            component={PhoenixAtHome}
          />
          <Route
            key="request-extension"
            path="/request-extension/:controlIdNumber"
            component={userIsAuthenticated(RequestExtension)}
          />
          <Route
              key="watch-group-delete"
              path="/watch-group-delete/:watchGroupId"
              component={WatchGroupDelete}
          />
          <Route
            key="calendar"
            path="/calendar/:employeeId"
            component={userIsAuthenticated(EmployeeCalendarRoute)}
          />
          <Route
            key="close-out-permission"
            path="/close-out-permission/:workitemid"
            component={UWPermissionToCloseResponse}
          />    
          <Route
            key="due-date-extend-permission"
            path="/extend-permission/:workitemid"
            component={UWPermissionToExtendResponse}
          />
          <Route
            key="customer-satisfaction-survey"
            path="/customer-satisfaction-survey/:uId"
            component={CustomerSatisfactionSurvey}
          />
          <Route
            key="support-line-satisfaction-survey"
            path="/support-line-satisfaction-survey/:uId"
            component={SupportLineSatisfactionSurvey}
          />
          <Route
            key="onboarding-satisfaction-survey"
            path="/onboarding-satisfaction-survey/:uId"
            component={OnboardingSatisfactionSurvey}
          />
          <Route
            key="customer-insights-survey"
            path="/customer-insights-survey/:uId"
            component={CustomerInsightsSurvey}
          />          
          <Route
            key="phoenix-form-preview"
            path="/form-preview/:phoenixFormId"
            component={PublicFormPreview}
          />
          <Route key="other" render={() => <AuthRoutes {...props} />} />
          <Route key="not-found" component={NotFoundPage} />
        </Switch>
      </LayoutContainer>
    </ErrorBoundary>
  );
}

Routes.propTypes = {
  persistor: PropTypes.object.isRequired
};

export default withRouter(Routes);
